'use client';

import { ComposableMenu } from '@quick/components/ComposableMenu';

import MenuOptions from '@/app/[lang]/(oppl)/MenuOptions';
import { useAppTranslation } from '@/app/i18n/client';
import { NotificationsProvider } from '@/components/core/OpPlLayout/Notifications';

export default function Menu() {
  const { t } = useAppTranslation(['common', 'OpPl']);

  return (
    <NotificationsProvider t={t}>
      <ComposableMenu
        className="animate-in slide-in-from-left shadow"
        options={<MenuOptions />}
      ></ComposableMenu>
    </NotificationsProvider>
  );
}
